export const NoSearchResultSvg = () => (
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.4519 49.1757L39.9199 44.5709L44.4689 40.0938L49.0009 44.6985L44.4519 49.1757Z"
      fill="#0D3880"
    />
    <path
      d="M29.697 49.256C29.6444 49.256 29.5919 49.256 29.5393 49.256C24.3119 49.2156 19.416 47.1416 15.7492 43.4182C12.0823 39.6947 10.0852 34.7624 10.1256 29.5391C10.166 24.3117 12.24 19.4158 15.9635 15.749C19.6869 12.0821 24.6192 10.093 29.8425 10.1254C35.0699 10.1658 39.9658 12.2398 43.6327 15.9632C51.2008 23.6527 51.1038 36.0642 43.4184 43.6324C39.7313 47.2629 34.8637 49.256 29.697 49.256ZM29.6889 15.2275C25.8684 15.2275 22.2703 16.699 19.5454 19.3835C16.7922 22.0922 15.26 25.7146 15.2317 29.5755C15.2034 33.4364 16.679 37.083 19.3877 39.8362C22.0964 42.5894 25.7188 44.1216 29.5797 44.1499C33.4487 44.1903 37.0873 42.7026 39.8405 39.9939C45.5247 34.3986 45.5934 25.2254 39.9981 19.5412C37.2894 16.788 33.6671 15.2558 29.8061 15.2275C29.7657 15.2275 29.7293 15.2275 29.6889 15.2275Z"
      fill="#0D3880"
    />
    <path
      d="M42.0657 48.4695L48.2601 42.3717C48.4214 42.2129 48.6786 42.2149 48.8375 42.3763L60.0718 53.7882C61.9123 55.658 61.8891 58.6709 60.0193 60.5114C58.1494 62.3524 55.136 62.3287 53.2953 60.4589L42.0612 49.0469C41.9023 48.8856 41.9044 48.6283 42.0657 48.4695Z"
      fill="#EE399E"
    />
    <path
      d="M64.2693 29.4368C64.1601 29.4368 64.0555 29.4456 63.9504 29.4543C63.5795 24.2061 59.2087 20.0625 53.869 20.0625C49.3281 20.0625 45.4902 23.0534 44.2108 27.1751C43.6869 26.9961 43.128 26.8957 42.5429 26.8957C39.6655 26.8957 37.334 29.2273 37.334 32.1047C37.334 32.4976 37.382 32.8775 37.465 33.2442H68.0812C68.0812 31.1441 66.3781 29.4368 64.2738 29.4368H64.2693Z"
      fill="#88E2E9"
    />
    <path
      d="M18.4797 55.9769C18.1141 55.9769 17.7668 56.0507 17.4473 56.1826C16.7652 52.9658 13.9108 50.5508 10.4911 50.5508C6.56124 50.5508 3.375 53.737 3.375 57.6668C3.375 58.0018 3.39958 58.3333 3.44567 58.6563H21.1589C21.1589 57.1781 19.9606 55.9769 18.4797 55.9769Z"
      fill="#88E2E9"
    />
  </svg>
);
